import { Link } from "react-router-dom";
import React, { useContext, useEffect, useRef, useState } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import animation from "../../../../Animation/services.json";

import { useGSAP } from "@gsap/react";
import { useTranslation } from "react-i18next";
import { Menu } from "../../../../Context/MenuOpen/MenuContext";
import Lottie from "react-lottie";

gsap.registerPlugin(ScrollTrigger);

const AboutEventManagement = () => {
    const {t , i18n} = useTranslation()
  const contentRef = useRef(null);
  const lottieContainerRef = useRef(null);
  const menu = useContext(Menu);
  const isOpen = menu.isOpen;
  const [playLottie, setPlayLottie] = useState(false);
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  useGSAP(() => {
    gsap.from(contentRef.current, {
      scrollTrigger: {
        trigger: contentRef.current,
        start: "top 80%",
        toggleActions: "play none none reverse",
      },
      opacity: 0,
      y: 50,
      duration: 1,
      ease: "power3.out",
    });
    ScrollTrigger.create({
      trigger: lottieContainerRef.current,
      start: "top 80%",
      toggleActions: "play reverse play reverse",
      onEnter: () => setPlayLottie(true),
    });
  });

  return (
    <div className="StartProject px-[7vw] py-7 !flex-row">
      <div className="content" ref={contentRef}>
        <p className="py-3 fz-[1.1rem]"> {t("EVENT MANAGEMENT")}</p>
        <h3>{t("Our philosophy")}</h3>
        <p>
          {t("At Sun Med, we believe that every event is more than just a moment, it’s an experience that tells a story. Our philosophy in event management blends technical precision with creative vision, ensuring that every detail from setup to live streaming works seamlessly to captivate your audience.")}
          <span className="mt-2 block">
            {t("For us, success is when you stay focused on your audience, while we handle everything behind the scenes flawlessly.")}
          </span>
        </p>
        <Link className="btn-hover">
          <span>{t("What’s include")}</span>
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="30"
              viewBox="0 0 24 24"
            >
              <g fill="currentColor">
                <path d="M5.636 20.364a9 9 0 1 1 12.728 0l1.414 1.414A10.97 10.97 0 0 0 23 14c0-6.075-4.925-11-11-11S1 7.925 1 14c0 3.038 1.231 5.788 3.222 7.778z" />
                <path d="M16.95 18.95a7 7 0 1 0-9.9 0l1.415-1.414a5 5 0 1 1 7.071 0z" />
                <path d="M14.121 16.121a3 3 0 1 0-4.243 0l1.415-1.414a1 1 0 1 1 1.414 0z" />
              </g>
            </svg>
          </span>
        </Link>
      </div>
      <div ref={lottieContainerRef} className="img">
      {playLottie || isOpen ? (
          <Lottie
            options={defaultOptions}
            className="custom-lottie"
            isClickToPauseDisabled={true}
          />
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default AboutEventManagement;
